
    import { Component, Vue, Prop } from 'vue-property-decorator';

    @Component
    export default class spinnerLogo extends Vue{
        @Prop({ default: '20px' }) readonly size!: String;
    }
